import React from "react";
import RecordVoiceOverRoundedIcon from "@mui/icons-material/RecordVoiceOverRounded";
import "./Commentary.scss";

interface CommentaryBadgeProps {
  /** Parent is responsible for stopping propagation (tiles open a bet modal on click). */
  onClick: (e: React.MouseEvent) => void;
}

// Pill badge that opens the AI pundit commentary modal. Styled in the
// Stadium-Night language but teal-accented to stand apart from the gold stage chip.
const CommentaryBadge: React.FC<CommentaryBadgeProps> = ({ onClick }) => (
  <button type="button" className="commentaryBadge" onClick={onClick}>
    <RecordVoiceOverRoundedIcon className="commentaryBadge__icon" />
    Commentary
  </button>
);

export default CommentaryBadge;
